import { useGetTerminalsList } from '@/modules/backoffice/services/terminals';
import {
  TerminalStatus,
  type TerminalFilterStatus,
  type TerminalRecordStatus,
} from '@/modules/backoffice/types/terminal';
import type { ITerminalTabCountFilters } from './use-terminal-tab-counts.type';

const useStatusCount = (
  status: TerminalRecordStatus | undefined,
  filters: ITerminalTabCountFilters,
) => {
  const { data } = useGetTerminalsList(
    {
      page: 0,
      limit: 1,
      status: status ? [status] : undefined,
      barteCompanyIds: filters.barteCompanyIds,
      companyName: filters.companyName,
      barteSellerIds: filters.barteSellerIds,
      sellerName: filters.sellerName,
      serialNumbers: filters.serialNumbers,
    },
    { staleTime: 30_000 },
  );
  return data?.data?.pageable?.totalRecords ?? null;
};

export const useTerminalTabCounts = (
  filters: ITerminalTabCountFilters,
): Record<TerminalFilterStatus, number | null> => {
  const allCount = useStatusCount(undefined, filters);
  const availableCount = useStatusCount(TerminalStatus.AVAILABLE, filters);
  const linkedCount = useStatusCount(TerminalStatus.LINKED, filters);
  const activeCount = useStatusCount(TerminalStatus.ACTIVE, filters);
  const inactiveCount = useStatusCount(TerminalStatus.INACTIVE, filters);
  const testCount = useStatusCount(TerminalStatus.TEST, filters);
  const supportCount = useStatusCount(TerminalStatus.SUPPORT, filters);

  return {
    [TerminalStatus.ALL]: allCount,
    [TerminalStatus.AVAILABLE]: availableCount,
    [TerminalStatus.LINKED]: linkedCount,
    [TerminalStatus.ACTIVE]: activeCount,
    [TerminalStatus.INACTIVE]: inactiveCount,
    [TerminalStatus.TEST]: testCount,
    [TerminalStatus.SUPPORT]: supportCount,
  };
};
